import type { StoreSpecial as V3StoreSpecial } from '@iheartjane/data-access';
import type { Nullable, QualifyingStatusEnum } from '@iheartjane/types';

/* eslint-disable-next-line no-restricted-imports */
import type { BrandSpecial, StoreSpecial } from '@jane/shared/models';
import type {
  BrandSpecial as zBrandSpecial,
  StoreSpecial as zStoreSpecial,
} from '@jane/shared/types';

interface SpecialFilterArgs {
  isBrandSpecial?: boolean;
  qualifyingStatus?: Nullable<QualifyingStatusEnum>;
  special?: Nullable<
    StoreSpecial | zStoreSpecial | BrandSpecial | zBrandSpecial | V3StoreSpecial
  >;
}

/**
 * @returns a filter string to be used as a static filter
 */
export const buildSpecialFilter = ({
  isBrandSpecial,
  special,
  qualifyingStatus,
}: SpecialFilterArgs) => {
  let specialFilter = '';

  switch (special?.special_type) {
    case 'product':
      specialFilter = `${isBrandSpecial ? 'brand_' : ''}special_ids`;

      break;
    case 'bundle':
    case 'buy_x_and_save':
    case 'buy_x_get_y':
      specialFilter =
        qualifyingStatus === 'applied' || qualifyingStatus === 'qualified'
          ? `${isBrandSpecial ? 'bundle_brand_' : 'bundle_'}special_ids.discount`
          : `${isBrandSpecial ? 'bundle_brand_' : 'bundle_'}special_ids.qualify`;
      break;
    case 'spending_threshold':
      specialFilter =
        qualifyingStatus === 'applied' || qualifyingStatus === 'qualified'
          ? 'any_discountable_special_ids'
          : 'any_qualifier_special_ids';
      break;
  }

  return specialFilter && special?.id
    ? `applicable_${specialFilter} = ${special.id}`
    : '';
};
